import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const StudentStrength = () => {
      useEffect(() => {
        document.title = 'Student Strength -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Student Strength </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Student Strength  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
          <div class="table-responsive maintable">
               <table class="table">
               <thead>
               <tr>
                   <th> S.NO. </th>
                   <th> Class </th>
                   <th> No. of Sections </th>
                   <th> No. of Students </th>
               </tr>
        </thead>
       <tbody>
          { /*  <tr>
               <td> 1 </td><td> Nursery </td><td> 2 </td><td> 39 </td>
           </tr>
           <tr>
               <td> 2 </td><td> LKG </td><td> 3 </td><td> 97 </td>
           </tr>
           <tr>
               <td> 3 </td><td> UKG </td><td> 4 </td><td> 130 </td>
           </tr>
               <tr>
               <td> 4 </td><td> I </td><td> 4 </td><td> 152 </td>
           </tr>
               <tr>
               <td> 5 </td><td> II </td><td> 5 </td><td> 171 </td>
           </tr>
               <tr>
               <td> 6 </td><td> III </td><td> 5 </td><td> 186 </td>
           </tr>
               <tr>
               <td> 7 </td><td> IV </td><td> 5 </td><td> 206 </td>
           </tr>
               <tr>
               <td> 8 </td><td> V </td><td> 5 </td><td> 174 </td>
           </tr>
               <tr>
               <td> 9 </td><td> VI </td><td> 5 </td><td> 181 </td>
           </tr>
               <tr>
               <td> 10 </td><td> VII </td><td> 5 </td><td> 168 </td>
           </tr>
               <tr>
               <td> 11 </td><td> VIII </td><td> 4 </td><td> 124 </td>
           </tr>
               <tr>
               <td> 12 </td><td> IX </td><td> 3 </td><td> 115 </td>
           </tr>
               <tr>
               <td> 13 </td><td> X </td><td> 3 </td><td> 98 </td>
  </tr> */ }

  <tr><td>1</td><td>NURSERY</td><td>2</td><td>45</td></tr>
<tr><td>2</td><td>LKG</td><td>3</td><td>74</td></tr>
<tr><td>3</td><td>UKG</td><td>4</td><td>123</td></tr>
<tr><td>4</td><td>I</td><td>4</td><td>157</td></tr>
<tr><td>5</td><td>II</td><td>5</td><td>163</td></tr>
<tr><td>6</td><td>III</td><td>5</td><td>185</td></tr>
<tr><td>7</td><td>IV</td><td>5</td><td>190</td></tr>
<tr><td>8</td><td>V</td><td>5</td><td>200</td></tr>
<tr><td>9</td><td>VI</td><td>5</td><td>186</td></tr>
<tr><td>10</td><td>VII</td><td>5</td><td>177</td></tr>
<tr><td>11</td><td>VIII</td><td>4</td><td>158</td></tr>
<tr><td>12</td><td>IX</td><td>3</td><td>118</td></tr>
<tr><td>13</td><td>X</td><td>3</td><td>114</td></tr>
        </tbody>
               </table>
         </div>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default StudentStrength
